import axios from 'axios'

// 401 policy for the v2 API (SOU-23.7). The v1 and v2 clients share the default axios instance, so this is ONE response
// interceptor, installed once, that only looks at requests sent to the v2 endpoint. It reports a 401 on an authorized call
// (the request carried an Authorization header); login, accessTokenLogin, logout and the password-reset calls are never reported.
const SKIPPED_PATHS = [
  'user/login',
  'user/accessTokenLogin',
  'user/logout',
  'user/google',
  'user/getResetPasswordToken',
  'user/resetPassword',
]

const hasAuthorization = headers => !!headers && Object.keys(headers).some(key => key.toLowerCase() === 'authorization' && !!headers[key])

export const isSessionExpiredResponse = error => {
  const { config, response } = error || {}
  if (response?.status !== 401 || !config || !hasAuthorization(config.headers)) return false
  const base = `${process.env.REACT_APP_API_V2_ENDPOINT}/`
  if (typeof config.url !== 'string' || !config.url.startsWith(base)) return false
  const path = config.url.slice(base.length).split('?')[0]
  return !SKIPPED_PATHS.includes(path)
}

let installed = false

export const installUnauthorizedInterceptor = onSessionExpired => {
  if (installed) return
  installed = true
  axios.interceptors.response.use(response => response, error => {
    if (isSessionExpiredResponse(error)) onSessionExpired(error)
    return Promise.reject(error)
  })
}

// test helper: the real app installs it once for the page lifetime
export const resetUnauthorizedInterceptorForTests = () => { installed = false }
